import { VStack } from "@chakra-ui/react";
import { MemoizedFeedCard } from "src/components/feed-card/feed-card";
import { IFeedCard } from "src/components/feed-card/types/feed-card";

export interface IFeedCardListProps {
    feedCards: IFeedCard[];
    onItemFirstSeen?: (contentId: string) => void;
    loadingTriggerElementOffset?: number;
    onLoadingTriggerElementMount?: (element: HTMLElement | null) => void;
}

export const FeedCardList = ({ feedCards, onItemFirstSeen, loadingTriggerElementOffset = 1, onLoadingTriggerElementMount }: IFeedCardListProps) => {
    return (
        <>
            {feedCards?.length ? (
                <VStack spacing={2} align="left">
                    {feedCards.map((card, index) => (
                        <MemoizedFeedCard
                            onMount={index === feedCards.length - loadingTriggerElementOffset ? onLoadingTriggerElementMount : undefined}
                            key={card.id}
                            onFirstSeen={onItemFirstSeen}
                            {...card}
                        />
                    ))}
                </VStack>
            ) : undefined}
        </>
    );
};
